const WhatsAppButton = () => {
  const handleClick = () => {
    window.open('https://wa.me/33632410246?text=Bonjour, je souhaite obtenir un devis pour un transport.', '_blank');
  };

  return (
    <a
      href="https://wa.me/33632410246"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer"
      aria-label="Contactez-nous sur WhatsApp"
    >
      <i className="ri-whatsapp-line text-white text-2xl"></i>
    </a>
  );
};

export default WhatsAppButton;
